export const trimText = (text, charactersToAppear, appendDots = true) => {
  if (text.length <= charactersToAppear) return text;

  const trimmedText = text.substr(0, charactersToAppear);
  return (appendDots && `${trimmedText}...`) || trimmedText;
};

export const serializeParams = params => {
  const keys = Object.keys(params);
  let options = '';
  keys.forEach(key => {
    if (Array.isArray(params[key])) {
      params[key].forEach(element => {
        options += `${key}=${element}&`;
      });
    } else if (key === 'beginDate' || key === 'endDate') {
      const date = new Date(params[key]).toISOString();
      options += `${key}=${date}&`;
    } else options += `${key}=${params[key]}&`;
  });
  return options ? options.slice(0, -1) : options;
};
